import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'

export const noteUrl = 'daily-note'

export interface DailyNoteModel extends DjangoModel {
  title: string
  text: string
  date: string
}

const {
  slice: noteSlice,
  thunks: noteThunks,
  adapter: noteAdapter,
  selectors,
} = createGenericSlice<DailyNoteModel>(
  'note',
  noteUrl,
  {}
  //noteExtraReducers  Initial state can be customized if needed
)

// export const noteAdapterExport = noteAdapter
export const { removeAll: clearAllNotes } = noteSlice.actions

export const {
  fetchAll: fetchAllNotes,
  delete: deleteNote,
  create: createNote,
  update: updateNote,
} = noteThunks

export const { selectAll: selectAllNotes } =
  noteAdapter.getSelectors<RootState>((state: RootState) => state.note)

export const {
  selectLoading: selectNoteLoading,
  selectIsIdInProgress: selectIsNoteIdInProgress,
  selectError: selectNoteError,
} = selectors

export default noteSlice.reducer
